declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

interface CheckoutStepAdvanceEvent {
  event: 'checkout_step_advance';
  step_index: number;
  step_name: string;
}

interface CheckoutDriverTypeSelectedEvent {
  event: 'checkout_driver_type_selected';
  driver_type: 'personal' | 'professional';
  user_id: number;
  timestamp: string;
}

interface CheckoutPlanSelectedEvent {
  event: 'checkout_plan_selected';
  plan_id: number;
  plan_name: string;
  plan_price: number;
  plan_interval: 'MONTH' | 'YEAR';
}

interface CheckoutPeriodToggledEvent {
  event: 'checkout_period_toggled';
  period: 'MONTH' | 'YEAR';
}

interface CheckoutPaymentFormatSelectedEvent {
  event: 'checkout_payment_format_selected';
  format: 'avista' | 'parcelado';
  installments: number;
}

interface CheckoutCompletedEvent {
  event: 'checkout_completed';
  plan_id: number;
  plan_name: string;
  plan_price: number;
  plan_interval: 'MONTH' | 'YEAR';
}

interface FormStartEvent {
  event: 'form_start';
}

interface StartVeiculoEvent {
  event: 'start_veiculo';
}

interface CompleteVeiculoEvent {
  event: 'complete_veiculo';
}

interface StartPerfilEvent {
  event: 'start_perfil';
}

interface CompletePerfilEvent {
  event: 'complete_perfil';
}

interface StartPlanoEvent {
  event: 'start_plano';
}

interface CompletePlanoEvent {
  event: 'complete_plano';
}

interface PaymentInfoEvent {
  event: 'payment_info';
}

interface CompleteRegistrationEvent {
  event: 'complete_registration';
}

type GTMEvent =
  | CheckoutStepAdvanceEvent
  | CheckoutDriverTypeSelectedEvent
  | CheckoutPlanSelectedEvent
  | CheckoutPeriodToggledEvent
  | CheckoutPaymentFormatSelectedEvent
  | CheckoutCompletedEvent
  | FormStartEvent
  | StartVeiculoEvent
  | CompleteVeiculoEvent
  | StartPerfilEvent
  | CompletePerfilEvent
  | StartPlanoEvent
  | CompletePlanoEvent
  | PaymentInfoEvent
  | CompleteRegistrationEvent;

export const pushGTMEvent = (gtmEvent: GTMEvent): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(gtmEvent);
};
